import React from "react";
import SeoHead from "../components/SeoHead";
import GeneralContactForm from "../components/GeneralContactForm";
import DogGroomingForm from "../components/DogGroomingForm";
import { BUSINESS_INFO } from "../data";

export default function Kontakt() {
  const [formTab, setFormTab] = React.useState("cleaning");

  return (
    <>
      <SeoHead
        title="Kontakt"
        description="Kontakt Ses Multi Service i Ørsted, Norddjurs. Ring på 40 94 75 40 eller send os en besked angående sommerhusrengøring, Airbnb-rengøring eller hundeklip."
        path="/kontakt"
      />

      {/* HEADER HERO */}
      <section className="bg-gradient-to-b from-[#F4EFE6] to-[#FAF7F2] py-12 lg:py-16 border-b border-[#EADFCF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-[#EADFCF] text-[#4B3C2D] px-3.5 py-1 rounded-full text-xs font-semibold mb-3">
            <i className="fa-solid fa-envelope" aria-hidden="true"></i>
            <span>Kontakt Ses Multi Service</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-heading text-[#2C2523]">
            Vi står klar til at hjælpe dig
          </h1>
          <p className="text-base text-[#5C524C] mt-3">
            Hvad enten du har spørgsmål om sommerhusrengøring, Airbnb-klargøring eller hundeklip, kan du altid ringe eller sende en besked.
          </p>
        </div>
      </section>

      {/* MAIN CONTENT GRID */}
      <section className="py-14 lg:py-20 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* COMPANY INFO CARDS */}
            <div className="lg:col-span-5 space-y-6">
              
              <div className="sand-card-light rounded-3xl p-8 border border-[#EADFCF] space-y-6 shadow-xs">
                <h2 className="text-2xl font-bold font-heading text-[#2C2523] border-b border-[#EADFCF] pb-4">
                  Virksomhedsoplysninger
                </h2>

                <div className="space-y-4 text-sm text-[#2C2523]">
                  <div>
                    <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block mb-0.5">Firma</span>
                    <p className="text-lg font-bold">{BUSINESS_INFO.name}</p>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-[#EADFCF] text-[#6B5640] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block">Adresse & Område</span>
                      <p className="font-semibold">8950 Ørsted</p>
                      <p className="text-xs text-[#5C524C] mt-1.5 leading-relaxed">
                        Baseret i Ørsted (8950) kører vi ud til sommerhuse og ferieboliger i hele Norddjurs, herunder Fjellerup Strand, Bønnerup Strand, Auning, Allingåbro, Vivild, Udbyhøj og omegn.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-[#EADFCF] text-[#6B5640] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block">Telefon</span>
                      <a 
                        href={`tel:${BUSINESS_INFO.phone}`} 
                        className="text-base font-bold text-[#2C2523] hover:underline whitespace-nowrap inline-block"
                      >
                        {BUSINESS_INFO.phoneFormatted}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-[#EADFCF] text-[#6B5640] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block">E-mail</span>
                      <a 
                        href={`mailto:${BUSINESS_INFO.email}`} 
                        className="font-semibold text-[#2C2523] hover:underline whitespace-nowrap inline-block"
                      >
                        {BUSINESS_INFO.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3 pt-2 border-t border-[#EADFCF]">
                    <div className="w-9 h-9 rounded-lg bg-[#EADFCF] text-[#6B5640] flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-id-card" aria-hidden="true"></i>
                    </div>
                    <div>
                      <span className="text-xs font-bold uppercase tracking-wider text-[#887055] block">CVR-Nummer</span>
                      <p className="font-mono text-sm font-semibold">{BUSINESS_INFO.cvr}</p>
                    </div>
                  </div>
                </div>

                <div className="pt-2 flex flex-col gap-2.5">
                  <a
                    href={BUSINESS_INFO.facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full inline-flex items-center justify-center gap-2 bg-[#3A302B] hover:bg-[#231C19] text-[#FFFDF9] px-4 py-3 rounded-xl text-xs font-semibold transition-colors shadow-xs"
                  >
                    <i className="fa-brands fa-facebook text-base" aria-hidden="true"></i>
                    <span>Besøg Ses Multi Service på Facebook</span>
                  </a>
                </div>
              </div>

              {/* AREA CARD */}
              <div className="bg-[#F4EFE6] rounded-2xl p-6 border border-[#EADFCF] space-y-2 text-xs text-[#5C524C]">
                <h3 className="text-sm font-bold text-[#2C2523] font-heading flex items-center gap-2">
                  <i className="fa-solid fa-compass text-[#887055]" aria-hidden="true"></i>
                  <span>Dækningsområde i Norddjurs</span>
                </h3>
                <p className="leading-relaxed">
                  Baseret i Ørsted (8950) kører vi ud til sommerhuse og ferieboliger i hele Norddjurs, herunder Fjellerup Strand, Bønnerup Strand, Auning, Allingåbro, Vivild, Udbyhøj og omegn.
                </p>
                <p className="text-[#7C6A5E] pt-1 border-t border-[#EADFCF]/80">
                  <span className="font-semibold">Bemærk:</span> Hundebad og klip foregår på vores private adresse i Ørsted efter forudgående aftale.
                </p>
              </div>

              {/* ÅBNINGSTIDER & TIDSBESTILLING CARD */}
              <div className="bg-[#FFFDF9] rounded-2xl p-6 border border-[#EADFCF] space-y-4 text-xs text-[#5C524C] shadow-xs">
                <h3 className="text-sm font-bold text-[#2C2523] font-heading flex items-center gap-2">
                  <i className="fa-solid fa-clock text-[#887055]" aria-hidden="true"></i>
                  <span>Tidsbestilling</span>
                </h3>

                <div className="space-y-3">
                  <div className="p-3 bg-[#FAF7F2] rounded-xl border border-[#EADFCF] space-y-1.5">
                    <span className="font-bold text-[#2C2523] flex items-center gap-1.5 text-xs">
                      <i className="fa-solid fa-dog text-[#887055]"></i>
                      Hundeklip:
                    </span>
                    <ul className="space-y-1 text-[#5C524C] pl-1">
                      <li>• Åben tirsdag til torsdag i hver uge</li>
                      <li>• Lukket alle helligdage</li>
                      <li>• Mellem 9 og 15</li>
                      <li>• Sep okt nov dec jan</li>
                    </ul>
                  </div>

                  <div className="p-3 bg-[#FAF7F2] rounded-xl border border-[#EADFCF] space-y-1.5">
                    <span className="font-bold text-[#2C2523] flex items-center gap-1.5 text-xs">
                      <i className="fa-solid fa-broom text-[#887055]"></i>
                      Rengøring:
                    </span>
                    <ul className="space-y-1 text-[#5C524C] pl-1">
                      <li>• Mandag til fredag</li>
                      <li>• Mellem 9 og 15</li>
                      <li>• Sep okt nov og dec</li>
                    </ul>
                  </div>

                  {/* Lukkeperioder & Ferie */}
                  <div className="p-3 bg-[#FFFDF9] rounded-xl border border-[#C2AB8E] space-y-2">
                    <div>
                      <span className="font-bold text-[#2C2523] flex items-center gap-1.5 text-xs">
                        <i className="fa-solid fa-calendar-xmark text-amber-700"></i>
                        Lukket for kundemodtagelse:
                      </span>
                      <p className="text-xs text-[#5C524C] mt-0.5">
                        Lukket i <strong>hele marts måned og til og med 4. april</strong>.
                      </p>
                    </div>
                    <div className="pt-2 border-t border-[#EADFCF]">
                      <span className="font-bold text-[#2C2523] flex items-center gap-1.5 text-xs">
                        <i className="fa-regular fa-snowflake text-[#887055]"></i>
                        Juleferie 2026/2027:
                      </span>
                      <p className="text-xs text-[#5C524C] mt-0.5">
                        Lukket fra den 20. december til og med den 3. januar 2027.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            {/* FORM CONTAINER WITH TABS FOR EASY SWITCHING */}
            <div className="lg:col-span-7">
              <div className="flex items-center gap-2 mb-6 p-1.5 bg-[#EADFCF]/60 rounded-2xl border border-[#EADFCF]">
                <button
                  type="button"
                  onClick={() => setFormTab("cleaning")}
                  className={`flex-1 py-3 px-4 rounded-xl text-xs sm:text-sm font-bold transition-all cursor-pointer flex items-center justify-center gap-2 ${
                    formTab === "cleaning"
                      ? "bg-[#3A302B] text-white shadow-xs"
                      : "text-[#5C524C] hover:text-[#2C2523]"
                  }`}
                >
                  <i className="fa-solid fa-broom" aria-hidden="true"></i>
                  <span>Rengøringshenvendelse</span>
                </button>

                <button
                  type="button"
                  onClick={() => setFormTab("grooming")}
                  className={`flex-1 py-3 px-4 rounded-xl text-xs sm:text-sm font-bold transition-all cursor-pointer flex items-center justify-center gap-2 ${
                    formTab === "grooming"
                      ? "bg-[#3A302B] text-white shadow-xs"
                      : "text-[#5C524C] hover:text-[#2C2523]"
                  }`}
                >
                  <i className="fa-solid fa-dog" aria-hidden="true"></i>
                  <span>Hundeklip & Vask</span>
                </button>
              </div>

              {formTab === "cleaning" ? (
                <GeneralContactForm defaultService="Sommerhusrengøring" />
              ) : (
                <DogGroomingForm />
              )}
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
